import { Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import PaiButton from 'features/ui/base-components/pai-button';
import PaiLink from 'features/ui/base-components/pai-link';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  open: boolean;
  loading: boolean;

  handleClose(): void;

  handleStartCampaignImmediately(): void;
}

const StartImmediatelyDialog: React.FC<Props> = ({ open, loading, handleClose, handleStartCampaignImmediately }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog classes={{ paper: classes.paper }} open={open} fullWidth={true} maxWidth={'sm'}>
      <DialogContent className={classes.content}>
        <Typography className={classes.text}>
          <Trans i18nKey={'campaignLinkedInWarning'}>
            <span className={classes.highlight}>Remember!</span> To start your campaign immediately, avoid using LinkedIn Recruiter. A double login
            may trigger LinkedIn’s security measures and block your account.
          </Trans>
        </Typography>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiLink text={t('cancel')} size={'sm'} underline={'always'} action={handleClose} />
        <PaiButton text={t('startGeneratingMessagesNow')} size={'small'} border={'rounded'} loading={loading} action={handleStartCampaignImmediately} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: '16px',
  },
  content: {
    padding: '32px !important',
    whiteSpace: 'pre-wrap',
  },
  text: {
    fontSize: theme.typography.pxToRem(15),
    whiteSpace: 'pre-wrap',
  },
  highlight: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default StartImmediatelyDialog;
